/**
 * Collection of scientific terms organized by discipline.
 * Includes terms from physics, chemistry, biology, and earth science.
 * Used for educational content and quiz generation.
 */
export const scienceTermsData = {
  /** Fundamental concepts and terms in physics */
  physics: [
    "Gravity",
    "Velocity",
    "Acceleration",
    "Force",
    "Mass",
    "Energy",
    "Pressure",
    "Temperature",
    "Density",
    "Volume",
    "Momentum",
    "Friction",
    "Wavelength",
    "Frequency",
    "Amplitude",
    "Magnetism",
    "Electricity",
    "Current",
    "Voltage",
    "Resistance",
    "Nuclear Fission",
    "Nuclear Fusion",
    "Quantum",
    "Relativity",
    "Thermodynamics",
  ],
  /** Chemical concepts and terminology */
  chemistry: [
    "Atom",
    "Molecule",
    "Chemical Reaction",
    "Element",
    "Compound",
    "Solution",
    "Solvent",
    "Solute",
    "Acid",
    "Base",
    "pH Scale",
    "Oxidation",
    "Reduction",
    "Catalyst",
    "Enzyme",
    "Isotope",
    "Ion",
    "Electron",
    "Proton",
    "Neutron",
    "Covalent Bond",
    "Ionic Bond",
    "Metallic Bond",
    "Periodic Table",
    "Valence",
  ],
  /** Biological terms and concepts */
  biology: [
    "Cell",
    "DNA",
    "RNA",
    "Evolution",
    "Photosynthesis",
    "Ecosystem",
    "Mitochondria",
    "Nucleus",
    "Chromosome",
    "Gene",
    "Protein",
    "Enzyme",
    "Metabolism",
    "Homeostasis",
    "Respiration",
    "Digestion",
    "Circulation",
    "Nervous System",
    "Immune System",
    "Hormone",
    "Bacteria",
    "Virus",
    "Species",
    "Adaptation",
    "Natural Selection",
  ],
  /** Earth science and environmental terms */
  earthScience: [
    "Atmosphere",
    "Lithosphere",
    "Hydrosphere",
    "Biosphere",
    "Plate Tectonics",
    "Volcano",
    "Earthquake",
    "Climate",
    "Weather",
    "Erosion",
    "Deposition",
    "Glacier",
    "Ocean Current",
    "Rock Cycle",
    "Mineral",
    "Fossil",
    "Sediment",
    "Groundwater",
    "Hurricane",
    "Tornado",
    "Greenhouse Effect",
    "Carbon Cycle",
    "Water Cycle",
    "Nitrogen Cycle",
    "Ozone Layer",
  ],
};
